import { Button } from "../ui/button";
import { Loader2 } from "lucide-react";

export function Empty({ icon: Icon, text, cta, onCta }) {
  return (
    <div className="text-center py-20 bg-white rounded-2xl border border-slate-200/80">
      <Icon size={40} className="mx-auto text-slate-300" />
      <p className="text-slate-500 mt-3">{text}</p>
      {cta && <Button onClick={onCta} className="mt-4 rounded-xl bg-[#F5551E] text-white">{cta}</Button>}
    </div>
  );
}

export const Loader = () => <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#F5551E]" size={28} /></div>;
